import React from 'react';
import { EditBoundsPoints } from './EditBoundsPoints';
export const EditImage = () => React.createElement(EditBoundsPoints, { keepAspectRatio: true });
